import { fromJS } from 'immutable';
import {
  SET_USER_PROFILE,
  SET_CORRELATION_ID,
} from './constants';

export const setUserProfile = (userProfile) => ({
  type: SET_USER_PROFILE,
  userProfile,
});

export const setCorrelationId = (correlationId) => ({
  type: SET_CORRELATION_ID,
  correlationId,
});

export function initialState() {
  return fromJS({
    userProfile: {},
    correlationId: '',
  });
}

export const reducer = (state = initialState(), action) => {
  if (action) {
    switch (action.type) {
      case SET_USER_PROFILE:
        return state.set('userProfile', fromJS(action.userProfile));
      case SET_CORRELATION_ID:
        return state.set('correlationId', fromJS(action.correlationId));
      default:
        return state;
    }
  }
  return state;
};
